"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentTextBox = void 0;
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const comment_text_box_constants_1 = require("./comment-text-box.constants");
const comment_text_box_styles_1 = require("./comment-text-box.styles");
const icons_1 = require("../../../../../../icons");
const localization_1 = require("../../../../../../localization");
const CommentTextBox = ({ isSubmitDisabled, isSubmitting, onSubmit, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const [comment, setComment] = (0, react_1.useState)('');
    const handleCommentChange = (e) => setComment(e.target.value);
    const handleIconButtonClick = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield (onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(comment));
            setComment('');
        }
        catch (e) { /* empty */ }
    });
    const isMaxLimitExceed = comment.length > comment_text_box_constants_1.MAX_COMMENT_LENGTH;
    const isSendButtonDisabled = !comment || isMaxLimitExceed || isSubmitDisabled;
    const errorMessage = (0, react_1.useMemo)(() => {
        if (!isMaxLimitExceed) {
            return null;
        }
        return (react_1.default.createElement(comment_text_box_styles_1.StyledErrorMessage, { color: "error", variant: "caption" }, react_1.default.createElement(icons_1.InfoIcon, { stroke: "currentColor" }), t({ key: 'VALIDATION_NOT_EXCEED_LIMIT_CHARACTERS', values: { limit: comment_text_box_constants_1.MAX_COMMENT_LENGTH } })));
    }, [isMaxLimitExceed, t]);
    const textBoxIcon = (react_1.default.createElement("div", { className: "text-box-footer" }, isSubmitting ? (react_1.default.createElement(comment_text_box_styles_1.StyledCreatingText, { color: "primary", variant: "button" }, t({ key: 'SENDING' }), react_1.default.createElement(icons_1.InProgressIcon, null))) : (react_1.default.createElement(material_1.IconButton, { className: "action-send", size: "small", disabled: isSendButtonDisabled, onClick: handleIconButtonClick }, react_1.default.createElement(icons_1.SendIcon, null)))));
    return (react_1.default.createElement(comment_text_box_styles_1.StyledTextBox, { multiline: true, variant: "outlined", rows: 4, value: comment, error: isMaxLimitExceed, helperText: errorMessage, onChange: handleCommentChange, placeholder: t({ key: 'PRODUCT_VIEWER_ADD_COMMENT_HINT' }), InputProps: {
            endAdornment: textBoxIcon,
        } }));
};
exports.CommentTextBox = CommentTextBox;
exports.default = exports.CommentTextBox;
